import { render, staticRenderFns } from "./UpdatedTimestampFormatter.vue?vue&type=template&id=b6192eb8&"
import script from "./UpdatedTimestampFormatter.vue?vue&type=script&lang=ts&"
export * from "./UpdatedTimestampFormatter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports